/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/executor/components/ExecutorWorkspaceFilterBar.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Executor Workspace
 *
 * DESCRIPTION:
 * Advanced filter bar for Executor Workspace.
 *
 * RESPONSIBILITIES
 * ----------------
 * ✓ Search Work
 * ✓ Filter by Status
 * ✓ Filter by Priority
 * ✓ Filter by Team
 * ✓ Filter by Due Date
 * ✓ Sort Work
 * ✓ Apply Filters
 * ✓ Reset Filters
 *
 ******************************************************************************/

import React from "react";

export default function ExecutorWorkspaceFilterBar({

    filters,

    onChange,

    onSearch,

    onReset,

}) {

    function handleChange(field, value) {

        onChange({

            ...filters,

            [field]: value,

        });

    }

    return (

        <div className="card shadow-sm mb-4">

            <div className="card-header">

                <h5 className="mb-0">

                    Advanced Filters

                </h5>

            </div>

            <div className="card-body">

                <div className="row">

                    {/* Search */}

                    <div className="col-lg-3 mb-3">

                        <label>

                            Search

                        </label>

                        <input

                            className="form-control"

                            placeholder="Work No / Title"

                            value={filters.search || ""}

                            onChange={(e) =>

                                handleChange(
                                    "search",
                                    e.target.value
                                )

                            }

                        />

                    </div>

                    {/* Status */}

                    <div className="col-lg-2 mb-3">

                        <label>

                            Status

                        </label>

                        <select

                            className="form-control"

                            value={filters.status || ""}

                            onChange={(e) =>

                                handleChange(
                                    "status",
                                    e.target.value
                                )

                            }

                        >

                            <option value="">

                                All

                            </option>

                            <option value="ASSIGNED">

                                Assigned

                            </option>

                            <option value="ACCEPTED">

                                Accepted

                            </option>

                            <option value="IN_PROGRESS">

                                In Progress

                            </option>

                            <option value="COMPLETED">

                                Completed

                            </option>

                            <option value="PENDING_APPROVAL">

                                Pending Approval

                            </option>

                        </select>

                    </div>

                    {/* Priority */}

                    <div className="col-lg-2 mb-3">

                        <label>

                            Priority

                        </label>

                        <select

                            className="form-control"

                            value={filters.priority || ""}

                            onChange={(e) =>

                                handleChange(
                                    "priority",
                                    e.target.value
                                )

                            }

                        >

                            <option value="">

                                All

                            </option>

                            <option value="CRITICAL">

                                Critical

                            </option>

                            <option value="HIGH">

                                High

                            </option>

                            <option value="MEDIUM">

                                Medium

                            </option>

                            <option value="LOW">

                                Low

                            </option>

                        </select>

                    </div>

                    {/* Team */}

                    <div className="col-lg-2 mb-3">

                        <label>

                            Team

                        </label>

                        <select

                            className="form-control"

                            value={filters.team || ""}

                            onChange={(e) =>

                                handleChange(
                                    "team",
                                    e.target.value
                                )

                            }

                        >

                            <option value="">

                                All

                            </option>

                            <option value="Maintenance">

                                Maintenance

                            </option>

                            <option value="Electrical">

                                Electrical

                            </option>

                            <option value="Utility">

                                Utility

                            </option>

                            <option value="Safety">

                                Safety

                            </option>

                        </select>

                    </div>

                    {/* Sort */}

                    <div className="col-lg-3 mb-3">

                        <label>

                            Sort By

                        </label>

                        <select

                            className="form-control"

                            value={filters.sort_by || ""}

                            onChange={(e) =>

                                handleChange(
                                    "sort_by",
                                    e.target.value
                                )

                            }

                        >

                            <option value="">

                                Priority

                            </option>

                            <option value="due_date">

                                Due Date

                            </option>

                            <option value="updated_at">

                                Recently Updated

                            </option>

                            <option value="title">

                                Title

                            </option>

                        </select>

                    </div>

                </div>

                <div className="d-flex justify-content-end gap-2">

                    <button

                        className="btn btn-outline-secondary"

                        onClick={onReset}

                    >

                        <i className="fas fa-undo me-2" />

                        Reset

                    </button>

                    <button

                        className="btn btn-primary"

                        onClick={onSearch}

                    >

                        <i className="fas fa-search me-2" />

                        Search

                    </button>

                </div>

            </div>

        </div>

    );

}